import React, { useState } from "react";
import "./Downloads.css";

export default function Downloads() {
  const [commissions] = useState([]);

  return (
    <div className="download-page">
      {/* Header */}
      <div className="page-header">
        <h2>Platform Downloads</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / View All
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h4>View all downloads</h4>

        {/* Top actions */}
        <div className="table-actions">
          <div className="left-buttons">
            <button>Copy</button>
            <button>CSV</button>
            <button>Excel</button>
            <button>PDF</button>
            <button>Print</button>
            <button className="dropdown-btn">Column visibility ▾</button>
          </div>
          <div className="right-buttons">
            <button className="btn-create">+ Create New</button>
          </div>
        </div>

        {/* Search Row */}
        <div className="search-box">
          <label>
            Search: <input type="text" />
          </label>
        </div>

        {/* Table */}
        <div className="table-wrapper">
          <table className="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Icon</th>
                <th>Name</th>
                <th>Description</th>
                <th>Link</th>
                <th>Active/Inactive</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            </tbody>
            <tbody>
              {commissions.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.ibCommission}</td>
                  <td>{item.amount}</td>
                  <td>{item.percent}</td>
                  <td>
                    <span
                      className={`status ${
                        item.status === "Active" ? "active" : "inactive"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td className="actions">
                    {item.status === "Active" ? (
                      <button className="btn-yellow">
                        <i className="fas fa-eye-slash"></i>
                      </button>
                    ) : (
                      <button className="btn-green">
                        <i className="fas fa-eye"></i>
                      </button>
                    )}
                    <button className="btn-blue">
                      <i className="fas fa-edit"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Pagination */}
        <div className="table-footer">
          <p>
            Showing 0 to {commissions.length} of {commissions.length} entries
          </p>
          <div className="pagination">
            <button disabled>Previous</button>
            <button className="active">1</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="page-footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </footer>
    </div>
  );
}
